import { ContainerWithHeader } from '@dealstack/frontend/shared/components/ContainerWithHeader/ContainerWithHeader';
import { Flex, Text } from '@mantine/core';
import { IconUserCheck } from '@tabler/icons-react';
import { TransformedPermission } from './UserPermissions.types';
import { PermissionRole } from '@dealstack/shared/lib/generated';
import { isPermissionRole } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

interface Props {
	handlePermissionChange: (permissionRole: PermissionRole, isEnabled: boolean) => void;
	text: {
		permissionTitle: string;
	};
	permissions: TransformedPermission[];
}

export const UserPermissions = ({ handlePermissionChange, text, permissions }: Props) => {
	return (
		<Flex direction="column" h="100%" w="100%">
			<ContainerWithHeader title={text.permissionTitle} icon={<IconUserCheck size={24} />}>
				<Flex direction="column" gap="1rem">
					{permissions.map((item) => {
						const handlePermissionToggle = () => {
							if (isPermissionRole(item.value)) {
								handlePermissionChange(item.value, item.checked);
							}
						};

						return (
							<AdvancedSwitch
								key={item.value}
								selectedValue={item.checked}
								onChange={handlePermissionToggle}
								disabled={item.disabled}
								align="flex-start"
								rightText={
									<Flex direction="column" align="start">
										<Text fz={14} c="dark.8">
											{item.label}
										</Text>

										<Text fz={12} c="gray.9">
											{item.description}
										</Text>
									</Flex>
								}
							/>
						);
					})}
				</Flex>
			</ContainerWithHeader>
		</Flex>
	);
};
